import { render, staticRenderFns } from "./AmaLink.vue?vue&type=template&id=1ecea931&scoped=true&"
import script from "./AmaLink.vue?vue&type=script&lang=js&"
export * from "./AmaLink.vue?vue&type=script&lang=js&"
import style0 from "./AmaLink.vue?vue&type=style&index=0&id=1ecea931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecea931",
  null
  
)

export default component.exports